import { baseUrl } from "../../utils/constants";
import { client } from "../client";
import { GETRIOGRID, GETRIOLIST, RIO } from "../endpoints";

export const createRIO = async (rioName: string) => {
  const response = await client.post(`${baseUrl}${RIO}`, {
    rioName,
  });
  return response;
};

export const updateRIO = async (rioId: number, rioName: string) => {
  const response = await client.put(`${baseUrl}${RIO}`, {
    rioId: rioId,
    rioName: rioName,
  });
  return response;
};

export const getAllRIO = async () => {
  const response = await client.get(`${baseUrl}${GETRIOLIST}`);
  return response;
};

export const getRIOGrid = async ({
  page,
  size,
  searchQuery,
}: {
  page: number;
  size: number;
  searchQuery: string;
}) => {
  const response = await client.get(`${baseUrl}${GETRIOGRID}`, {
    params: {
      page,
      size,
      searchQuery,
    },
  });
  return response;
};

export const getRIOById = async (rioId: number) => {
  const response = await client.get(`${baseUrl}${RIO}?rioId=${rioId}`);
  return response;
};

export const removeRIOFromUser = async (rioId: number) => {
  const response = await client.delete(`${baseUrl}${RIO}`, {
    data: {
      rioId: rioId,
    },
  });
  return response;
};
